import { cn } from '@helpers/styleUtils';
import * as AccordionPrimitive from '@radix-ui/react-accordion';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { LuChevronDown } from 'react-icons/lu';

const Accordion = AccordionPrimitive.Root;

const AccordionItem = forwardRef(({ className, ...props }, ref) => (
    <AccordionPrimitive.Item ref={ref} className={cn('w-full', className)} {...props} />
));
AccordionItem.displayName = 'AccordionItem';

const AccordionTrigger = forwardRef(({ className, children, ...props }, ref) => (
    <AccordionPrimitive.Header className="flex">
        <AccordionPrimitive.Trigger
            ref={ref}
            className={cn(
                'flex flex-1 items-center justify-between py-2 text-sm font-medium transition-all w-full hover:underline text-left [&[data-state=open]>svg]:rotate-180',
                className,
            )}
            {...props}
        >
            {children}
            <LuChevronDown className="h-4 w-4 shrink-0 text-muted-foreground transition-transform duration-200" />
        </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
));
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;

const AccordionContent = forwardRef(({ className, children, ...props }, ref) => (
    <AccordionPrimitive.Content
        ref={ref}
        className="overflow-hidden text-sm data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
        {...props}
    >
        <div className={cn('pb-4 pt-0', className)}>{children}</div>
    </AccordionPrimitive.Content>
));
AccordionContent.displayName = AccordionPrimitive.Content.displayName;

AccordionContent.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
};

AccordionTrigger.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
};

AccordionItem.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
};

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };
